<!--
 * @Description: 加载动画
 * @Author: 山淑兰
 * @Date: 2019-11-12 10:36:09
 * @LastEditTime : 2019-12-21 21:47:01
 * @LastEditors  : 山淑兰
 -->
<template>
  <div id="loading">
    <div class="loading_con">
      <div class="loading-blue"></div>
      <img src="@assets/loading.png" alt />
      <div class="loadingText">努力加载中...</div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'loading',

}
</script>
<style lang="scss" scoped>
@keyframes fadeUp {
  0% {
    height: 0%;
  }
  100% {
    height: 97%;
  }
}
#loading {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background: #fff;
  z-index: 99999;
  overflow: hidden;
}
.loading_con {
  width: 140px;
  height: 140px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #eee;
}
#loading img {
  width: 100%;
  height: 100%;
  position: absolute;
}
.loading-blue {
  animation: fadeUp 2s linear 1s infinite alternate;
  width: 97%;
  position: absolute;
  bottom: 1px;
  left: 1%;
  background: rgb(17, 122, 241);
}
.loadingText {
  position: absolute;
  bottom: -66px;
  width: 200px;
  left: 0;
  color: #aaa;
  font-size: 28px;
}
</style>